import React, { useEffect, useState } from 'react';

import { Select } from 'antd';
import countries from 'country-region-data';

interface IProps {
    onChange?: any;
    value?: any;
    mode: any;
    countryShortCode: string;
    disabled?: boolean;
}

interface IData {
    countryName: string;
    countryShortCode: string;
    regions: [
        {
            name: string;
            shortCode: string;
        }
    ];
}

const SelectStates: React.FC<IProps> = props => {
    const [value, setValue] = useState<any>(props.value || {});
    const [data, setData] = useState<IData>();

    useEffect(() => {
        const getCountries = countries.find(country => country.countryShortCode === props.countryShortCode);

        setValue(props.value);
        if (getCountries) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setData(getCountries);
        }
    }, [props]);

    const onChangeSelect = (value: string) => {
        const { onChange } = props;

        if (!('value' in props)) {
            setValue(value);
        }

        if (onChange) {
            onChange(value);
        }
    };

    return (
        <Select
            showSearch
            labelInValue
            optionFilterProp="children"
            onChange={onChangeSelect}
            value={value}
            mode={props.mode || 'default'}
            size="large"
            style={{ minWidth: '199px' }}
            disabled={props.disabled}
        >
            {data?.regions.map(row => (
                <Select.Option key={row.shortCode} value={row.shortCode}>
                    {row.name}
                </Select.Option>
            ))}
        </Select>
    );
};

export default SelectStates;
